export { kaart };

let initializeKaart, setMarkersKaart;

const kaart = () => {
    if (MODULE_NAME === "kaart") {
        initializeKaart = function() {
            var mapOptions = {
                zoom: 7,
                center: new google.maps.LatLng(59.067566, 25.047626)
            }
            var map = new google.maps.Map(document.getElementById("map-canvas"), mapOptions);
            setMarkersKaart(map, pointers);
        }
    
        setMarkersKaart = function(map, locations) {
            var image,
                markers = [],
                shape = {
                    coord: [1, 1, 1, 20, 18, 20, 18, 1],
                    type: "poly"
                },
                image;
            for (var i = 0; i < locations.length; i++) {
                var place = locations[i];
                var myLatLng = new google.maps.LatLng(place[1], place[2]);
    
                image = {
                    url: place[4],
                    // This marker is 20 pixels wide by 32 pixels tall.
                    size: new google.maps.Size(35, 40),
                    // The origin for this image is 0,0.
                    origin: new google.maps.Point(0, 0),
                    // The anchor for this image is the base of the flagpole at 0,32.
                    anchor: new google.maps.Point(0, 32)
                };
                markers[i] = new google.maps.Marker({
                    position: myLatLng,
                    map: map,
                    icon: image,
                    //shape: shape,
                    title: place[0],
                    url: place[6]
                });
            }
            for (i = 0; i < markers.length; i++) {
                google.maps.event.addListener(markers[i], "click", function () {
                    //console.log(this);
                    //window.location.href = this.url;  //changed from markers[i] to this[i]
                    window.open(this.url);
                });
            }
        }
    
        window.addEventListener("load", initializeKaart);
    }
}